import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerActividades=async(token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const ingresarActividad=async(actividad,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"POST",
            body:JSON.stringify(actividad)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerActividad=async(actividadId,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades/`+actividadId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
           
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarActividad=async(actividad,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(actividad)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const deshabilitarActividad=async(actividadid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades/`;
    const resp=await fetch(url,
        {
            method:"DELETE",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify({ActividadId:actividadid})
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};
